import { BaseLayer } from './BaseLayer'
import { apiFzu } from '@/apiFzu'
import { createBridgeLabels, drawDeck, drawPier } from './BridgeRenderUtils'
import * as Cesium from 'cesium'
import BridgePopup from '../../views/Map/Popup/BridgePopup.vue'
import { Subscriber } from 'cesium-extends'

import { useBridgeStore } from '@/stores/bridge'
import { useMarkStore } from '@/stores/navimark'

export class BridgeLayer extends BaseLayer {
  layername: string = '桥梁'
  key: string = 'bridge'
  private labelEntities: Cesium.Entity[] = []

  constructor() {
    super()
    this.once('mounted', (viewer) => {
      this._subscriber = new Subscriber(viewer, { pickResult: { enable: true } })
    })
  }

  async render(): Promise<void> {
    const geojsons = await this.loadGeojson()

    // 绘制桥墩
    drawPier(geojsons).forEach((el) => {
      el.pierPrimitives.forEach((p) => this.layer.primitiveCollection.add(p))
    })

    // 绘制桥面
    drawDeck(geojsons).forEach((el) => {
      el.deckPrimitives.forEach((p) => this.layer.primitiveCollection.add(p))
    })

    // 绘制桥梁名称标签
    if (this._viewer) {
      this.labelEntities = createBridgeLabels(geojsons)
      this.labelEntities.forEach((entity) => {
        this._viewer!.entities.add(entity)
      })

      // 添加交互监听器
      this._subscriber?.add(
        this.labelEntities,
        (_e, entity) => {
          const viewer = this._viewer
          if (!viewer || !entity) return
          const position = entity.position?.getValue()
          if (!position) return
          const cartographic = Cesium.Cartographic.fromCartesian(position)
          const userBridgeStore = useBridgeStore()
          const userMarkStore = useMarkStore()
          const bridgeId = entity.properties?.getValue().id
          this.popupCtrl.closeAll()
          userMarkStore.closeDetail()
          userBridgeStore.openBridgeDetail(bridgeId),
            this.popupCtrl.popup({
              viewer,
              id: entity.id,
              Com: BridgePopup as any,
              lnglat: [
                Cesium.Math.toDegrees(cartographic.longitude),
                Cesium.Math.toDegrees(cartographic.latitude),
              ] as [number, number],
              properties: entity.properties?.getValue(),
            })
        },
        'LEFT_CLICK'
      )
    }
  }

  destroy(): void {
    // 清理标签
    if (this._viewer) {
      this.labelEntities.forEach((entity) => {
        this._viewer!.entities.remove(entity)
      })
    }

    this.labelEntities = []
    // 调用父类方法
    this.layer.primitiveCollection.removeAll()
  }

  private async loadGeojson() {
    const res = await apiFzu.bridge.bridgeControllerList()
    return res.data
  }
}
